import axios, { HttpStatusCode } from 'axios';

/**
 * Tells whether an API error is the 409 Conflict returned when the manager has already decided on the plea.
 */
export function isPleaDecidedConflict(error: unknown): boolean {
  return axios.isAxiosError(error) && error.response?.status === HttpStatusCode.Conflict;
}
